module.exports = __webpack_public_path__ + "img/facebook.58cb1ca7.svg";